import * as React from 'react';
import { AuthContext } from 'helpers/authcontext';

export function withAuthContext(Component) {
	return function WrapperComponent(props) {
		return <AuthContext.Consumer>{(state) => <Component {...props} context={state} />}</AuthContext.Consumer>;
	};
}
